import type { SimpleRequestConfig } from 'modules/app/types';
import type { ApiError, EmptyResponseBody, MetaAction } from 'modules/global/generic.types';
import { deleteMessagingAccountFailure, deleteMessagingAccountSuccess } from 'modules/messagingAccounts/actions';
import * as types from 'modules/messagingAccounts/actionTypes';
import type { DeleteMessagingAccountAction } from 'modules/messagingAccounts/types';
import { conflictFailureNotification } from 'modules/messagingAccounts/utils';

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [types.CREATE_MESSAGING_ACCOUNT]: {
    notifications: {
      success: { id: 'page.config.smsAccount.create.success', defaultMessage: 'SMS account created successfully.' },
      failure: conflictFailureNotification({
        id: 'page.config.smsAccount.create.failure',
        defaultMessage: 'An error occurred during the SMS account creation.',
      }),
    },
  },
  [types.UPDATE_MESSAGING_ACCOUNT]: {
    notifications: {
      success: { id: 'page.config.smsAccount.update.success', defaultMessage: 'SMS account updated successfully.' },
      failure: conflictFailureNotification({
        id: 'page.config.smsAccount.update.failure',
        defaultMessage: 'An error occurred during the SMS account update.',
      }),
    },
  },
  [types.DELETE_MESSAGING_ACCOUNT]: {
    callbacks: {
      success: (_: EmptyResponseBody, meta: MetaAction, { payload }: DeleteMessagingAccountAction) =>
        deleteMessagingAccountSuccess(payload.accountId, meta),
      failure: (error: ApiError, meta: MetaAction, { payload }: DeleteMessagingAccountAction) =>
        deleteMessagingAccountFailure(error, { ...meta, entityId: payload.accountId }),
    },
    notifications: {
      success: { id: 'page.config.smsAccount.delete.success', defaultMessage: 'SMS account deleted successfully.' },
      failure: conflictFailureNotification({
        id: 'page.config.smsAccount.delete.failure',
        defaultMessage: 'An error occurred during the SMS account deletion.',
      }),
    },
  },
};

export default simpleRequests;
